import {trainingDrills, trainingInfo,trainingOption1Bundle, trainingOption2Bundle, why, goldstar} from './BasketballTrainingData.js'
import PurchaseList from '../../components/PurchaseList';
import Location from '../../components/Location.jsx'
import LogisiticsDetails from '../../components/LogisiticsDetails';
import 'animate.css';

export default function Training() {
  return (
    <section className="section d-flex flex-column align-items-center justify-content-center">
      <div className="info camps__container animate__animated animate__fadeInRight">
        <h4>Gold Star Co-Ed Basketball Open House Nov 21st</h4>
        <div className='camp__container'>
          <div className="purchase">
          <PurchaseList 
            type="ThreeDayBundle"
            header="Mini Madness K to 2nd Grade"
            subhead="Sat Start Time 9AM"
            data={trainingOption1Bundle}
          />
             <PurchaseList 
            type="ThreeDayBundle"
            header="Not So Mini 3rd to 4th Grade"
            subhead="Sat Start Time 10:30AM"
            data={trainingOption2Bundle}
          />
                  <LogisiticsDetails 
            header="Why 606 Academy"
            data={goldstar}
          />
              <LogisiticsDetails 
            header="Important Notes"
            data={trainingInfo}
          />
        </div>

        <div className='logistics'>
        <Location 
            link="https://maps.app.goo.gl/bzJQMCjncGWaXhTH6"
            name="Lotus Elementary School"
            street="29067 W Grass Lake Rd"
            city=" Fox Lake, IL 60020"
          />
            <LogisiticsDetails 
            header="Why 606 Academy"
            data={why}
          />
          <LogisiticsDetails 
            header="Skills & Drills Focus"
            data={trainingDrills}        
          />
        </div>

      </div>
      {/* close camp container div */}
    </div>
    {/* close info div */}
  </section>
)
}